import React from 'react';
import classNames from 'classnames';
const HelpText = ({ className, children }) => {
    const css = classNames('help-text', className);
    return React.createElement("div", { className: css }, children);
};
export { HelpText };
//# sourceMappingURL=HelpText.js.map